import { gql } from '@apollo/client';

const CREATE_UPDATE_INCOMINGORDERS_VIEW = gql`mutation createUpdateIncomingOrdersView($input: IncomingOrdersViewInput)
{
	incomingOrders{
		createUpdateView(input: $input){
			success
			result{
				groupId
				id
				name
				settings
			}
			errorResult{
				errorCode
				errorMessage
				data{
					key
					value
				}
			}
		}
	}
}`;

export default CREATE_UPDATE_INCOMINGORDERS_VIEW;